<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" :selectTab="tabList[tabIndex].tabIndex" style="min-width: 1200px"></tab>

    <img src="@/assets/image/banner4.jpg" width="100%" alt="" />
    <div class="main flex-row justify-content-spaceBetween align-items-center margin-ts margin-b border-b">
      <p class="fs-mid grey">当前位置：首页 > 下属企业</p>
      <!--      <div class="flex-row justify-content-center border align-items-center searchBox">-->
      <!--        <input type="text" class="fs-mid search margin-r" placeholder="点击输入搜索新闻/关键词" />-->
      <!--        <van-icon name="search" color="#999999" class="margin-l" size="20" />-->
      <!--      </div>-->
    </div>
    <div class="main flex-row justify-content-center align-items-center">
      <p
        :class="{ 'myBgBlue white': item.index === tabIndex }"
        @click="select(item.index)"
        v-for="item in tabList"
        :key="item.index"
        class="tab pointer"
      >
        {{ item.text }}
      </p>
    </div>
    <div class="cutLine-h margin-bs"></div>
    <div
      @click="newsDetail(item.id)"
      @mouseenter="addClassload(index)"
      @mouseleave="removeClassload()"
      :class="{ 'bg-slightGrey': classEnable && current === index }"
      v-for="(item, index) in enterprise"
      :key="index"
      class="pointer main select paddingTb flex-row justify-content-around align-items-star"
    >
      <div class="width-90 paddingLr90">
        <p class="fs-big fw-mid margin-bs">{{ item.title }}</p>
        <p class="fs-mid lineHeight2">{{ item.summary }}<span class="myBlue" style="display: inline">[查看详细]</span></p>
      </div>
    </div>
    <el-empty v-if="enterprise.length === 0" description="暂无下属企业信息"></el-empty>
    <van-pagination @change="pageChange()" class="margin-ts" v-model="currentPage" :total-items="total" :items-per-page="4" :show-page-size="5">
      <template #prev-text>
        <van-icon name="arrow-left" />
      </template>
      <template #next-text>
        <van-icon name="arrow" />
      </template>
      <template #page="{ text }">{{ text }}</template>
    </van-pagination>
    <backBtn></backBtn>

    <footerBox class="margin-t"></footerBox>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import footerBox from '@/components/footer.vue';
import backBtn from '@/components/backBtn.vue';
import newsApi from '@/api/newsApi';

export default {
  name: 'enterprise',
  components: {
    tab,
    footerBox,
    backBtn
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 4,
      tabIndex: 0,
      classEnable: false,
      current: 0,
      total: 0,
      enterprise: [],
      // tabList: [
      //   {
      //     index: 0,
      //     text: '全资企业',
      //     type: '016',
      //     tabIndex: '4-1'
      //   },
      //   {
      //     index: 1,
      //     text: '控股企业',
      //     type: '017',
      //     tabIndex: '4-2'
      //   },
      //   {
      //     index: 2,
      //     text: '参股企业',
      //     type: '022',
      //     tabIndex: '4-3'
      //   },
      //   {
      //     index: 3,
      //     text: '全管企业',
      //     type: '023',
      //     tabIndex: '4-4'
      //   }
      // ]
      tabList: [
        {
          index: 0,
          text: '全资及控股子公司',
          type: '0032',
          tabIndex: '4-1'
        },
        {
          index: 1,
          text: '直管企业',
          type: '0033',
          tabIndex: '4-2'
        },
        {
          index: 2,
          text: '参股企业',
          type: '0034',
          tabIndex: '4-3'
        }
      ]
    };
  },
  watch: {
    '$route.query.Id'(newVal) {
      this.tabIndex = parseInt(newVal);
    }
  },
  created() {
    this.tabIndex = parseInt(this.$route.query.Id) || 0;

    let tabIndex = this.$route.query.param;
    if (tabIndex !== undefined && tabIndex !== null) {
      this.tabIndex = parseInt(tabIndex);
    }
    this.mountedData();
  },
  methods: {
    mountedData() {
      newsApi
        .list({
          status: '1',
          params: {
            likeType: this.tabList[this.tabIndex].type
          }
        })
        .then((res) => {
          this.total = res.total;
        })
        .catch((err) => {
          console.log(err);
        });
      newsApi
        .list({ status: '1', params: { pageNum: this.currentPage, pageSize: this.pageSize, likeType: this.tabList[this.tabIndex].type } })
        .then((res) => {
          this.enterprise = res.rows;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    pageChange() {
      newsApi
        .list({ status: '1', params: { pageNum: this.currentPage, pageSize: this.pageSize, likeType: this.tabList[this.tabIndex].type } })
        .then((res) => {
          this.enterprise = res.rows;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    newsDetail(id) {
      let text = this.$router.resolve({ path: '/newsDetail', query: { type: 'enterprise', newsId: id } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    },
    select(e) {
      this.tabIndex = e;
      this.mountedData();
    },
    addClassload(e) {
      this.classEnable = true;
      this.current = e;
    },
    removeClassload() {
      this.classEnable = false;
      // this.current=index;
    },

    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    }
  }
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 60px;
}
.search {
  border: none !important;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}
.tab {
  background: #eeeeee;
  padding: 10px 40px;
  margin: 0 2px;
}
.border-b {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}
.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
</style>
